import { useEffect, useState } from "react";
import {
    fetchBusinessCaseDeadline,
    setBusinessCaseWindow,
} from "../api/tcg";

// Wandelt ISO-Datum in den Wert für <input type="datetime-local">.
function toLocalInput(iso: string | null): string {
    if (!iso) return "";
    const d = new Date(iso);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function BusinessCaseDeadline({ token, onUpdated }: { token: string; onUpdated?: () => void | Promise<void> }) {
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [currentStart, setCurrentStart] = useState<string | null>(null);
    const [currentEnd, setCurrentEnd] = useState<string | null>(null);
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    async function load() {
        try {
            const data = await fetchBusinessCaseDeadline();
            setCurrentStart(data.starts_at);
            setCurrentEnd(data.deadline);
            setStart(toLocalInput(data.starts_at));
            setEnd(toLocalInput(data.deadline));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Konnte Zeitplan nicht laden.");
        }
    }

    useEffect(() => { load(); }, []);

    async function handleSave() {
        setBusy(true);
        setMessage(null);
        setError(null);

        try {
            await setBusinessCaseWindow(token, { starts_at: start || null, deadline: end || null });
            await load();
            await onUpdated?.();
            setMessage("Zeitplan gespeichert.");
        } catch (err) {
            setError(err instanceof Error ? err.message : "Speichern fehlgeschlagen.");
        } finally {
            setBusy(false);
        }
    }

    async function handleClear() {
        setBusy(true);
        setMessage(null);
        setError(null);

        try {
            await setBusinessCaseWindow(token, { starts_at: null, deadline: null });
            await load();
            await onUpdated?.();
            setMessage("Zeitplan entfernt.");
        } catch (err) {
            setError(err instanceof Error ? err.message : "Entfernen fehlgeschlagen.");
        } finally {
            setBusy(false);
        }
    }

    return (
        <section className="admin-card">
            <h2 className="admin-card-title">Business-Case-Zeitplan</h2>

            <p className="admin-note" style={{ marginBottom: "16px" }}>
                Unabhängig von den Award-Phasen. Aktuell:{" "}
                <strong>{currentStart ? new Date(currentStart).toLocaleString() : "—"}</strong>
                {" → "}
                <strong>{currentEnd ? new Date(currentEnd).toLocaleString() : "—"}</strong>
            </p>

            {message && <p className="admin-success">{message}</p>}
            {error && <p className="admin-error">{error}</p>}

            <div className="admin-control-row">
                <label className="admin-label">Einreichung – Start</label>
                <input
                    className="admin-input"
                    type="datetime-local"
                    value={start}
                    onChange={(e) => setStart(e.target.value)}
                />

                <label className="admin-label">Einreichung – Ende</label>
                <input
                    className="admin-input"
                    type="datetime-local"
                    value={end}
                    onChange={(e) => setEnd(e.target.value)}
                />
            </div>

            <div className="admin-actions">
                <button className="admin-btn-primary" onClick={handleSave} disabled={busy}>
                    Speichern
                </button>
                <button className="admin-btn-secondary" onClick={handleClear} disabled={busy}>
                    Entfernen
                </button>
            </div>
        </section>
    );
}

export default BusinessCaseDeadline;
